<datex-grid #$gridComponent *ngIf="initialized "  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



[rowCommandTemplateRef]="rowCommand">
    <ng-template #rowCommand let-row>
      <div mat-menu-item class="grid-row-options">
        <button mat-menu-item
                class="datex-button"
                [disabled]="row.options.edit_transaction.readOnly"
                [ngStyle]="row.options.edit_transaction.styles.style"
                [ngClass]="row.options.edit_transaction.styles.classes"
                (click)="row.on_edit_transaction()">
          <span *ngIf="row.options.edit_transaction.label">{{row.options.edit_transaction.label}}</span>
        </button>
      </div>
    </ng-template>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="pallet_transaction" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_create_pallet_transaction($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-aggregate" *ngIf="!filters.aggregate.hidden && !filters.aggregate.removed" 
            class="field-container standard {{filters.aggregate.invalid ? 'invalid' : ''}} {{filters.aggregate.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.aggregate.styles.style"
            [ngClass]="filters.aggregate.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.aggregate.label + (filters.aggregate.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.aggregate.label}}<span *ngIf="filters.aggregate.required" class="required-asterisk">*</span>
          </label>
        </div>
        <mat-slide-toggle data-cy="slideToggle" formControlName="aggregate"
                      color="primary"
                      class="datex-toggle"
                      [ngStyle]="filters.aggregate.control.styles.style"
                      [ngClass]="filters.aggregate.control.styles.classes"
                      [matTooltip]="filters.aggregate.control.tooltip"
                      matTooltipClass="datex-control-tooltip">{{filters.aggregate.control.label}}</mat-slide-toggle>
        <ng-container *ngIf="filters.aggregate.invalid">
          <ng-container *ngFor="let error of filters.aggregate.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="PalletClass">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.PalletClass.displayControl.styles.style"
          [ngClass]="row.cells.PalletClass.displayControl.styles.classes"
          [matTooltip]="row.cells.PalletClass.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.PalletClass.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Amount.displayControl.styles.style"
          [ngClass]="row.cells.Amount.displayControl.styles.classes"
          [matTooltip]="row.cells.Amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Direction">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Direction.displayControl.styles.style"
          [ngClass]="row.cells.Direction.displayControl.styles.classes"
          [matTooltip]="row.cells.Direction.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Direction.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="In">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.In.displayControl.styles.style"
          [ngClass]="row.cells.In.displayControl.styles.classes"
          [matTooltip]="row.cells.In.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.In.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Out">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Out.displayControl.styles.style"
          [ngClass]="row.cells.Out.displayControl.styles.classes"
          [matTooltip]="row.cells.Out.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Out.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Reference">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Reference.displayControl.styles.style"
          [ngClass]="row.cells.Reference.displayControl.styles.classes"
          [matTooltip]="row.cells.Reference.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Reference.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Notes">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Notes.displayControl.styles.style"
          [ngClass]="row.cells.Notes.displayControl.styles.classes"
          [matTooltip]="row.cells.Notes.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Notes.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Employee">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Employee.displayControl.styles.style"
          [ngClass]="row.cells.Employee.displayControl.styles.classes"
          [matTooltip]="row.cells.Employee.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Employee.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Date">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Date.displayControl.styles.style"
          [ngClass]="row.cells.Date.displayControl.styles.classes"
          [matTooltip]="row.cells.Date.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Date.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
